import { JobProgress } from '@app/components/base/JobProgress';
import { LDateTime } from '@app/components/date/LDateTime';
import { AodRun } from '@app/modules/audit/modules/aod/aod.types';
import { Box, CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  run: AodRun;
}

export function ReprocessProgress({ run }: Props) {
  const { $t } = useIntl();

  if (!run.isReprocessStarted || !run.reprocessJobStatus) {
    return null;
  }

  return (
    <Box>
      {run.reprocessJobStatus.progressPercent === 0 ? (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={16} />
          {$t({
            id: 'audit.aod.actions.triggerReprocess.waiting',
            defaultMessage: 'El reprocesamiento está esperando para iniciar',
          })}
        </Box>
      ) : (
        <Box>
          <Box mb={1}>
            {$t({
              id: 'audit.aod.actions.triggerReprocess.startedAt',
              defaultMessage: 'Iniciado el ',
            })}{' '}
            <LDateTime value={run.reprocessJobStatus.processedOn!} />
          </Box>
          <JobProgress showOnlyProgress job={run.reprocessJobStatus} />
        </Box>
      )}
    </Box>
  );
}
